import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import NewsLayout  from "./pages/news/Layout";
import NewsV1Home  from "./pages/news/V1Home";
import { NewsV1Section, NewsV1Article, NewsV1Contact } from "./pages/news/V1Pages";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Toaster richColors position="top-right" />
        <Routes>
          <Route path="/" element={<NewsLayout theme="newsv1" base="" />}>
            <Route index element={<NewsV1Home />} />
            <Route path="section/:slug" element={<NewsV1Section />} />
            <Route path="article/:slug" element={<NewsV1Article />} />
            <Route path="contact" element={<NewsV1Contact />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
